import { ImportConfigurationClientAccessType, ImportConfigurationManualImportDTO } from './../../../../base/models/models.swagger.generated';
import { FieldAssignmentsValidator } from '../field-assignments-validator';
import { IImportConfigurationFieldAssignmentExtendedDTO } from './configuration-form-file/configuration-field-assignment-extended-dto';
import { FieldAssignmentDefinitionsService } from '../field-assignment-definitions.service';
import { IWeekdays } from '../../../../base/shared/week-day-flags.helper';
import { CreateConfigurationUtil } from '../create-configuration.util';
import { BitHelper } from '../../../../base/shared/bit-helper';
import { CustomValidatorsFactory } from '../../../../base/shared/validators/custom-validators-factory';
import { ImportConfigurationTimeSceduleFormType, WeekdaysFormType } from './configuration-form-timescedule/configuration-form-timescedule-form-type';
import { ImportConfigurationEmailFormType } from './configuration-form-email/configuration-form-email-form-type';
import { ImportConfigurationSftpFormType } from './configuration-form-sftp/configuration-form-sftp-form-type';
import { ImportConfigurationFtpFormType } from './configuration-form-ftp/configuration-form-ftp-form-type';
import { ImportConfigurationRestFormType } from './configuration-form-rest/configuration-form-rest-form-type';
import { ImportConfigurationAs2FormType } from './configuration-form-as2/configuration-form-as2-form-type';
import { ImportConfigurationFileFormType } from './configuration-form-file/configuration-form-file-form-type';
import { ImportConfigurationGeneralFormType } from './configuration-form-general/configuration-form-general-form-type';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Injectable, EventEmitter } from '@angular/core';
import { DateTime } from 'luxon';
import { DurationHelper } from 'src/app/base/shared/duration-helper';
import { ClientDTO, MediaStorageType, ExportInterfaceConfigurationDecimalSeparator, ExportInterfaceConfigurationTextFormat, ImportSourceFieldDefinitionDTO, FilterDTO, ImportConfigurationDTO, ImportConfigurationTransferType, ImportConfigurationFileDTO, ImportConfigurationFieldAssignmentDTO, ImportFieldAssignmentTargetDefinitionDTO, ImportFunction, ImportFileFormat, ImportConfigurationUserAssignmentDTO, ExportInterfaceConfigurationRESTAuthType, ImportType, FTPClientType, ExportInterfaceConfigurationDTO, ImportConfigurationAcodisDTO, NavisionImportTemplate, ImportConfigurationType } from 'src/app/base/models/models.swagger.generated';
import { WeekDayFlagsHelper } from 'src/app/base/shared/week-day-flags.helper';
import { ImportConfigurationAcodisFormType } from './configuration-form-acodis/configuration-form-acodis-form-type';
import { ImportConfigurationManualImportFormType } from './configuration-form-manual-import/configuration-form-manual-import-form-type';


@Injectable({
  providedIn: 'root'
})
export class ImportConfigurationEditFormsCoordinatorService {

  public get configuration(): ImportConfigurationDTO {
    return this._configuration;
  }

  public set configuration(value: ImportConfigurationDTO) {
    this._configuration = value;
    if (value == null) {
      this.resetForms();
      this.configurationUpdated.emit();
      return;
    }
    this.loadFormsData();
    this.configurationUpdated.emit();
  }

  public configurationUpdated: EventEmitter<void> = new EventEmitter();

  public isWholeFormValid = true;
  public isInitialFormValid = true;

  public configurationFormGeneral: FormGroup<ImportConfigurationGeneralFormType>;
  public configurationFormTimeschedule: FormGroup<ImportConfigurationTimeSceduleFormType>;
  public configurationFormEmail: FormGroup<ImportConfigurationEmailFormType>;
  public configurationFormSftp: FormGroup<ImportConfigurationSftpFormType>;
  public configurationFormFtp: FormGroup<ImportConfigurationFtpFormType>;
  public configurationFormRest: FormGroup<ImportConfigurationRestFormType>;
  public configurationFormAs2: FormGroup<ImportConfigurationAs2FormType>;
  public configurationFormFile: FormGroup<ImportConfigurationFileFormType>;
  public configurationFormAcodis: FormGroup<ImportConfigurationAcodisFormType>;
  public configurationFormManualImport: FormGroup<ImportConfigurationManualImportFormType>;

  private _configuration: ImportConfigurationDTO = null;

  constructor(
    private fb: FormBuilder,
    private fieldAssignmentDefinitionsService: FieldAssignmentDefinitionsService,
  ) {
    this.initializeForms();
  }

  public duplicateActualConfiguration(): ImportConfigurationDTO {
    if (this.configuration == null) {
      return null;
    }

    const configuration = new ImportConfigurationDTO(this.configuration);
    configuration.id = 0;
    configuration.configurationName += " Copy";
    if (configuration.fTPClientConfig) {
      configuration.fTPClientConfig.certificateMediaId = null;
      configuration.fTPClientConfig.certificateMediaName = null;
      configuration.fTPClientConfig.certificatePassword = null;
      configuration.fTPClientConfig.certificateMediaType = null;
      configuration.fTPClientConfig.certificateContentBase64 = null;
    }

    if (configuration.as2Config) {
      configuration.as2Config.certificateMediaId = null;
      configuration.as2Config.certificateMediaName = null;
      configuration.as2Config.certificatePassword = null;
      configuration.as2Config.certificateMediaType = null;
      configuration.as2Config.certificateContentBase64 = null;
    }

    if (configuration.rESTConfig) {
      configuration.rESTConfig.aPIFixKey = null;
      configuration.rESTConfig.aPIFixValue = null;
      configuration.rESTConfig.clientId = null;
      configuration.rESTConfig.clientSecret = null;
    }

    return configuration;
  }

  public copyFromTemplate(template: ImportConfigurationDTO): ImportConfigurationDTO {
    if (template == null) {
      return null;
    }
    const configuration = new ImportConfigurationDTO(template);
    configuration.id = 0;
    configuration.type = ImportConfigurationType.Configuration;
    configuration.copiedFromId = template.id;
    return configuration;
  }

  public resetForms() {
    this.configurationFormGeneral.reset();
    this.configurationFormTimeschedule.reset();
    this.configurationFormEmail.reset();
    this.configurationFormSftp.reset();
    this.configurationFormFtp.reset();
    this.configurationFormRest.reset();
    this.configurationFormAs2.reset();
    this.configurationFormFile.reset();
    this.configurationFormAcodis.reset();
    this.configurationFormManualImport.reset();

    this.resetFormStatus();
  }

  public isFormDirty(): boolean {
    return this.configurationFormGeneral.dirty ||
      this.configurationFormTimeschedule.dirty ||
      this.configurationFormEmail.dirty ||
      this.configurationFormSftp.dirty ||
      this.configurationFormFtp.dirty ||
      this.configurationFormRest.dirty ||
      this.configurationFormAs2.dirty ||
      this.configurationFormFile.dirty ||
      this.configurationFormAcodis.dirty ||
      this.configurationFormManualImport.dirty;
  }

  public setFormDirty() {
    this.configurationFormGeneral.markAllAsTouched();
    this.configurationFormGeneral.markAsDirty();
    this.configurationFormTimeschedule.markAllAsTouched();
    this.configurationFormTimeschedule.markAsDirty();
    this.configurationFormEmail.markAllAsTouched();
    this.configurationFormEmail.markAsDirty();
    this.configurationFormSftp.markAllAsTouched();
    this.configurationFormSftp.markAsDirty();
    this.configurationFormFtp.markAllAsTouched();
    this.configurationFormFtp.markAsDirty();
    this.configurationFormRest.markAllAsTouched();
    this.configurationFormRest.markAsDirty();
    this.configurationFormAs2.markAllAsTouched();
    this.configurationFormAs2.markAsDirty();
    this.configurationFormFile.markAllAsTouched();
    this.configurationFormFile.markAsDirty();
    this.configurationFormAcodis.markAllAsTouched();
    this.configurationFormAcodis.markAsDirty();
    this.configurationFormManualImport.markAllAsTouched();
    this.configurationFormManualImport.markAsDirty();
  }

  public validateWholeForm() {
    var optionalTabsValid = false;
    var transferType = this.configurationFormGeneral.controls.transferType.value;
    var importType = this.configurationFormGeneral.controls.importType.value;
    switch (transferType) {
      case ImportConfigurationTransferType.Email:
        optionalTabsValid = this.configurationFormEmail.valid;
        break;
      case ImportConfigurationTransferType.SFTPServer:
        optionalTabsValid = this.configurationFormSftp.valid;
        break;
      case ImportConfigurationTransferType.FTPClient:
        optionalTabsValid = this.configurationFormFtp.valid && this.configurationFormTimeschedule.valid;
        break;
      case ImportConfigurationTransferType.REST:
        optionalTabsValid = this.configurationFormRest.valid;
        break;
      case ImportConfigurationTransferType.AS2:
        optionalTabsValid = this.configurationFormAs2.valid;
        break;
      case ImportConfigurationTransferType.Acodis:
        optionalTabsValid = this.configurationFormAcodis.valid;
        break;
      case ImportConfigurationTransferType.ManualImport:
        optionalTabsValid = this.configurationFormManualImport.valid;
        break;
      case ImportConfigurationTransferType.Magento:
        optionalTabsValid = true;
        break;
      case ImportConfigurationTransferType.Zir:
        optionalTabsValid = true;
        break;
      default:
        // undefined type
        optionalTabsValid = false;
        break;
    }
    var fileType = this.configurationFormFile.controls.fileFormat.value;
    if ((fileType === ImportFileFormat.PDF || transferType === ImportConfigurationTransferType.Acodis) && importType !== ImportType.Parashift) {
      optionalTabsValid = this.configurationFormAcodis.valid && optionalTabsValid;
    }
    var isValid = this.configurationFormGeneral.valid && optionalTabsValid;
    if (transferType !== ImportConfigurationTransferType.REST
      && transferType !== ImportConfigurationTransferType.Acodis
      && transferType !== ImportConfigurationTransferType.Magento
      && transferType !== ImportConfigurationTransferType.Zir
      && importType !== ImportType.Parashift) {
      isValid = isValid && this.configurationFormFile.valid;
    }

    this.isWholeFormValid = isValid;
  }

  public getDtoFromForm(): ImportConfigurationDTO {
    if (!this.configuration) {
      return null;
    }
    this.updateConfigurationFromForm(this.configuration);
    return this.configuration;
  }

  public setValidatorsForGeneralConfigForm() {
    var transferType = this.configurationFormGeneral.controls.transferType.value;
    if ((
      transferType == ImportConfigurationTransferType.SFTPServer ||
      transferType == ImportConfigurationTransferType.REST
      && this.configurationFormRest?.controls?.restAccessType.value === ExportInterfaceConfigurationRESTAuthType.BearerToken
      || transferType == ImportConfigurationTransferType.AS2
    )
      && this.configurationFormGeneral.controls.type.value == ImportConfigurationType.Configuration
      && this.configurationFormGeneral.controls.clientAccessType.value === ImportConfigurationClientAccessType.Client) {
      this.configurationFormGeneral.controls.userAssignments.setValidators([Validators.required]);
    } else {
      this.configurationFormGeneral.controls.userAssignments.clearValidators();
    }
    this.configurationFormGeneral.controls.userAssignments.updateValueAndValidity();

    if (this.configurationFormGeneral.controls.type.value == ImportConfigurationType.Template ||
      this.configurationFormGeneral.controls.clientAccessType.value === ImportConfigurationClientAccessType.Global) {
      this.configurationFormGeneral.controls.client.clearValidators();
    }
    else {
      this.configurationFormGeneral.controls.client.setValidators([Validators.required]);
    }
    this.configurationFormGeneral.controls.client.updateValueAndValidity();
  }

  public setValidatorsForTimeScheduleConfigForm() {
    if (this.configurationFormTimeschedule.controls.hasEndDate.value == true) {
      this.configurationFormTimeschedule.controls.endDate.setValidators([Validators.required]);
      this.configurationFormTimeschedule.controls.endDate.enable();
    } else {
      this.configurationFormTimeschedule.controls.endDate.setValue(null);
      this.configurationFormTimeschedule.controls.endDate.clearValidators();
      this.configurationFormTimeschedule.controls.endDate.disable();
    }
    this.configurationFormTimeschedule.controls.endDate.updateValueAndValidity();
  }

  public setValidatorsForFtpConfigForm() {
    if (this.configurationFormFtp.controls.useCertificate.value == true) {
      this.configurationFormFtp.addValidators([CustomValidatorsFactory.atLeastOneRequired(['certificateMediaId', 'certificateContentBase64'])]);
    } else {
      this.configurationFormFtp.clearValidators();
    }

    this.configurationFormFtp.updateValueAndValidity();
  }

  public setValidatorsForRestConfigForm() {
    if (this.configurationFormRest.controls.restAccessType.value == ExportInterfaceConfigurationRESTAuthType.BearerToken) {
      this.configurationFormRest.controls.refreshTokenLifetimeInHours.setValidators([Validators.required]);
    } else {
      this.configurationFormRest.controls.refreshTokenLifetimeInHours.clearValidators();
    }
    this.configurationFormRest.controls.refreshTokenLifetimeInHours.updateValueAndValidity();
  }

  public setValidatorsForAs2ConfigForm() {
    if (this.configurationFormAs2.controls.doSignMessages.value == true) {
      this.configurationFormAs2.addValidators([CustomValidatorsFactory.atLeastOneRequired(['certificateMediaId', 'certificateContentBase64'])]);
    } else {
      this.configurationFormAs2.clearValidators();
    }

    this.configurationFormAs2.updateValueAndValidity();
  }

  public setValidatorsForFileConfigForm() {
    if (this.configurationFormFile.controls.fileFormat.value == ImportFileFormat.CSV) {
      this.configurationFormFile.controls.seperatorCharacter.setValidators([Validators.required, CustomValidatorsFactory.compareFieldSeparaterAndDecimalSeparaterOnControl()]);
      this.configurationFormFile.controls.decimalSeperator.setValidators([Validators.required]);
      this.configurationFormFile.controls.textFormat.setValidators([Validators.required]);
      this.configurationFormFile.controls.isTitleContainedInFile.setValidators([Validators.required]);
    } else {
      this.configurationFormFile.controls.seperatorCharacter.clearValidators();
      this.configurationFormFile.controls.decimalSeperator.clearValidators();
      this.configurationFormFile.controls.textFormat.clearValidators();
      this.configurationFormFile.controls.isTitleContainedInFile.clearValidators();
    }
    this.configurationFormFile.controls.seperatorCharacter.updateValueAndValidity();
    this.configurationFormFile.controls.decimalSeperator.updateValueAndValidity();
    this.configurationFormFile.controls.textFormat.updateValueAndValidity();
    this.configurationFormFile.controls.isTitleContainedInFile.updateValueAndValidity();

    if (this.configurationFormGeneral.controls.importType.value == ImportType.Parashift) {
      this.configurationFormFile.controls.fileFormat.clearValidators();
    }
    this.setValidatorsForFieldAssignments();
  }

  public setValidatorsForFieldAssignments() {
    if (this.configurationFormFile.controls.fileFormat.value == ImportFileFormat.PDF
      || this.configurationFormGeneral.controls.transferType.value == ImportConfigurationTransferType.Acodis
      || this.configurationFormGeneral.controls.transferType.value == ImportConfigurationTransferType.Magento
      || this.configurationFormGeneral.controls.transferType.value == ImportConfigurationTransferType.Zir
      || this.configurationFormGeneral.controls.importType.value == ImportType.Parashift
    ) {
      this.configurationFormFile.controls.fieldAssignments.clearValidators();
    } else {
      const importType = this.configurationFormGeneral.controls.importType.value;
      this.configurationFormFile.controls.fieldAssignments.setValidators([FieldAssignmentsValidator.fieldAssignmentsValidator(this.fieldAssignmentDefinitionsService, importType)]);
    }
    this.configurationFormFile.controls.fieldAssignments.updateValueAndValidity();
  }

  public completeFieldAssignments() {
    if (this._configuration == null) {
      return;
    }
    const importType = this.configurationFormGeneral.controls.importType.value;
    const targetDefinitions = this.fieldAssignmentDefinitionsService.getTargetDefinitionsImmediately(importType);
    var fieldAssignments = this.configurationFormFile.controls.fieldAssignments.value;

    //TODO check if needed later on
    if (fieldAssignments == null || targetDefinitions == null) {
      return;
    }

    //If definition is not available anymore -> remove
    var remove = [];
    fieldAssignments.forEach(fa => {
      if (!targetDefinitions.some(td => td.targetName === fa.targetName)) {
        remove.push(fa);
      }
    });
    remove.forEach(r => fieldAssignments.splice(fieldAssignments.indexOf(r), 1));

    //Check if all targetNames are included in the fieldAssignments. if not -> complete
    targetDefinitions.forEach(td => {
      if (!fieldAssignments.some(e => e.targetName === td.targetName)) {
        fieldAssignments.push(this.addNewFieldAssignment(td));
      }
    });

    //When its an edifact file, complete fieldAssignments with definitions
    if (this.configurationFormFile.controls.fileFormat.value == ImportFileFormat.EDIFACT) {
      fieldAssignments.forEach(fa => {
        var targetDefinition = targetDefinitions.find(td => td.targetName === fa.targetName);
        fa.sourceElementName = targetDefinition.edifactSourceDefinition.sourceElementName;
        fa.sourceElementSelectionPath = targetDefinition.edifactSourceDefinition.sourceElementSelectionPath;
        fa.position = targetDefinition.edifactSourceDefinition.position;
      });
    }

    //Select first supportedFunction if no function is selected
    fieldAssignments.forEach(fa => {
      if (fa.importFunction == null && fa.fixValue == null) {
        fa.importFunction = targetDefinitions.find(td => td.targetName === fa.targetName).supportedFunctions[0];
      }
    });

    // Sort by required (those that don't have ImportFunction.NoData), then by targetName
    fieldAssignments.sort((a, b) => {
      const aIsRequired = !targetDefinitions.find(td => td.targetName === a.targetName).supportedFunctions.includes(ImportFunction.NoData);
      const bIsRequired = !targetDefinitions.find(td => td.targetName === b.targetName).supportedFunctions.includes(ImportFunction.NoData);

      if (aIsRequired === bIsRequired) {
        return a.targetName.localeCompare(b.targetName);
      }
      return aIsRequired ? -1 : 1;
    });

    this.configurationFormFile.controls.fieldAssignments.setValue(fieldAssignments);
    this.validateFieldAssignments(importType);
  }

  public validateFieldAssignments(importType: ImportType) {
    const targetDefinitions = this.fieldAssignmentDefinitionsService.getTargetDefinitionsImmediately(importType);
    const functionDefinitions = this.fieldAssignmentDefinitionsService.getFunctionDefinitionsImmediately(importType);
    this.configurationFormFile.controls.fieldAssignments.value.forEach(fa => {
      var targetDefinition = targetDefinitions.find(td => td.targetName === fa.targetName);
      var functionDefinition = functionDefinitions.find(fd => fd.importFunction === fa.importFunction);
      fa.valid = fa.fixValue != null || (functionDefinition != null && this.isStaticFunctionUsed(functionDefinition.importFunction))
        || (fa.sourceElementName != null && (
          fa.importFunction == null || (targetDefinition.supportedFunctions.some(sf => sf == fa.importFunction) &&
            (functionDefinition?.parameter1?.isMandatory ? fa.functionParameter1Value != null : true) &&
            (functionDefinition?.parameter2?.isMandatory ? fa.functionParameter2Value != null : true) &&
            (functionDefinition?.parameter3?.isMandatory ? fa.functionParameter3Value != null : true) &&
            (functionDefinition?.parameter4?.isMandatory ? fa.functionParameter4Value != null : true) &&
            (functionDefinition?.parameter5?.isMandatory ? fa.functionParameter5Value != null : true))));
    });
  }

  private isStaticFunctionUsed(functionName: ImportFunction): boolean {
    return functionName === ImportFunction.ToToday
      || functionName === ImportFunction.FixDate
      || functionName === ImportFunction.NoData
      || functionName === ImportFunction.VendorNoLookup;
  }

  private addNewFieldAssignment(targetDefinition: ImportFieldAssignmentTargetDefinitionDTO): IImportConfigurationFieldAssignmentExtendedDTO {
    return ({
      targetName: targetDefinition.targetName,
      isGroupingElement: targetDefinition.defaultValueDefinition?.isGroupingElement ?? false,
      importFunction: null,
      fixValue: null,
      cap: null,
      setValueAsNull: false,
      sourceElementName: null,
      sourceElementSelectionPath: null,//ignore and return
      position: null,//ignore and return
      functionParameter1Value: null,
      functionParameter2Value: null,
      functionParameter3Value: null,
      functionParameter4Value: null,
      functionParameter5Value: null,
      valid: false
    } as IImportConfigurationFieldAssignmentExtendedDTO);
  }

  private resetFormStatus(): void {
    this.configurationFormGeneral.markAsPristine();
    this.configurationFormTimeschedule.markAsPristine();
    this.configurationFormEmail.markAsPristine();
    this.configurationFormSftp.markAsPristine();
    this.configurationFormFtp.markAsPristine();
    this.configurationFormRest.markAsPristine();
    this.configurationFormAs2.markAsPristine();
    this.configurationFormFile.markAsPristine();
    this.configurationFormAcodis.markAsPristine();
    this.configurationFormManualImport.markAsPristine();
  }

  private loadFormsData() {
    this.resetForms();

    this.loadGeneralConfigForm();
    this.loadTimeScheduleConfigForm();
    this.loadEmailConfigForm();
    this.loadSFTPConfigForm();
    this.loadFTPClientForm();
    this.loadRESTConfigForm();
    this.loadAs2ConfigForm();
    this.loadFileConfigForm();
    this.loadAcodisConfigForm();
    this.loadManualImportConfigForm();
    this.resetFormStatus();

    //Validate existing configuration and show in case there are errors
    if (this._configuration.id) {
      this.validateWholeForm()
      if (!this.isWholeFormValid) {
        this.isInitialFormValid = false;
      } else {
        this.isInitialFormValid = true;
      }
    }
  }

  private loadGeneralConfigForm() {
    this.configurationFormGeneral.setValue({
      client: this._configuration.client ?? null,
      name: this._configuration.configurationName ?? null,
      transferType: this._configuration.transferType ?? null,
      importType: this._configuration.importType ?? ImportType.SalesOrder,
      isActive: this._configuration.isActive ?? true,
      userAssignments: this._configuration.userAssignments ?? null,
      type: this._configuration.type ?? ImportConfigurationType.Configuration,
      clientAccessType: this._configuration.clientAccessType ?? ImportConfigurationClientAccessType.Client,
    });

    this.setValidatorsForGeneralConfigForm();
  }

  private loadTimeScheduleConfigForm() {
    const timeScheduleConfig = this._configuration?.timeScheduleConfig ?? CreateConfigurationUtil.createNewTimeScheduleDto();
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var startTime = new Date(today);
    timeScheduleConfig.startTime?.as('seconds') > 0 ? startTime.setSeconds(timeScheduleConfig.startTime.as('seconds')) : startTime = null;

    var endTime = new Date(today);
    timeScheduleConfig.endTime?.as('seconds') > 0 ? endTime.setSeconds(timeScheduleConfig.endTime.as('seconds')) : endTime = null;

    this.configurationFormTimeschedule.setValue({
      startDate: timeScheduleConfig.startDate?.toJSDate() ?? null,
      hasEndDate: timeScheduleConfig.hasEndDate ?? false,
      endDate: timeScheduleConfig.endDate?.toJSDate() ?? null,
      startTime: startTime,
      endTime: endTime,
      repetitionIntervalInMinutes: timeScheduleConfig.repetitionIntervalInMinutes ?? null,
      weekdays: {
        allowedMonday: BitHelper.isBitSet(timeScheduleConfig.onWeekDays, 0),
        allowedTuesday: BitHelper.isBitSet(timeScheduleConfig.onWeekDays, 1),
        allowedWednesday: BitHelper.isBitSet(timeScheduleConfig.onWeekDays, 2),
        allowedThursday: BitHelper.isBitSet(timeScheduleConfig.onWeekDays, 3),
        allowedFriday: BitHelper.isBitSet(timeScheduleConfig.onWeekDays, 4),
        allowedSaturday: BitHelper.isBitSet(timeScheduleConfig.onWeekDays, 5),
        allowedSunday: BitHelper.isBitSet(timeScheduleConfig.onWeekDays, 6),
      }
    });

    this.setValidatorsForTimeScheduleConfigForm();
  }

  private loadEmailConfigForm() {
    const emailConfig = this._configuration?.emailConfig ?? CreateConfigurationUtil.createNewEmailDto();
    this.configurationFormEmail.setValue({
      emailAccountId: emailConfig.emailAccountId ?? null,
      mandatorySubjectContent: emailConfig.mandatorySubjectContent ?? null,
      mandatoryBodyContent: emailConfig.mandatoryBodyContent ?? null,
      senderEmailAddress: emailConfig.senderEmailAddress ?? null
    });
  }

  private loadSFTPConfigForm() {
    const sftpConfig = this._configuration?.sFTPConfig ?? CreateConfigurationUtil.createNewSftpDto();
    if (this._configuration.sFTPConfig) {
      this.configurationFormSftp.setValue({

      });
    }
  }

  private loadFTPClientForm() {
    const ftpclient = this._configuration?.fTPClientConfig ?? CreateConfigurationUtil.createNewFtpClientDto();
    this.configurationFormFtp.setValue({
      url: ftpclient.url ?? null,
      port: ftpclient.port ?? null,
      ftpClientType: ftpclient.fTPClientType ?? null,
      userName: ftpclient.userName ?? null,
      password: ftpclient.password ?? null,
      relativePath: ftpclient.relativePath ?? null,
      deleteFilesAfterTransmission: ftpclient.deleteFilesAfterTransmission ?? true,
      useCertificate: ftpclient.useCertificate ?? false,
      certificateMediaId: ftpclient.certificateMediaId ?? null,
      certificateMediaName: ftpclient.certificateMediaName ?? null,
      certificatePassword: ftpclient.certificatePassword ?? null,
      certificateMediaType: ftpclient.certificateMediaType ?? null,
      certificateContentBase64: null
    });

    this.setValidatorsForFtpConfigForm();
  }

  private loadRESTConfigForm() {
    const restConfig = this._configuration?.rESTConfig ?? CreateConfigurationUtil.createNewRestDto();
    this.configurationFormRest.setValue({
      restAccessType: restConfig.accessType ?? ExportInterfaceConfigurationRESTAuthType.BearerToken,
      clientId: restConfig.clientId ?? null,
      clientSecret: restConfig.clientSecret ?? null,
      apiKey: restConfig.aPIFixKey ?? null,
      apiValue: restConfig.aPIFixValue ?? null,
      refreshTokenLifetimeInHours: restConfig.refreshTokenLifetimeInHours ?? null
    });

    this.setValidatorsForRestConfigForm();
  }

  private loadAs2ConfigForm() {
    const as2Config = this._configuration?.as2Config ?? CreateConfigurationUtil.createNewAs2Dto();
    this.configurationFormAs2.setValue({
      as2From: as2Config.aS2From ?? null,
      as2To: as2Config.aS2To ?? null,
      useCompression: as2Config.useCompression ?? true,
      doSignMessages: as2Config.doSignMessages ?? false,
      certificateMediaId: as2Config.certificateMediaId ?? null,
      certificateMediaName: as2Config.certificateMediaName ?? null,
      certificatePassword: as2Config.certificatePassword ?? null,
      certificateMediaType: as2Config.certificateMediaType ?? null,
      certificateContentBase64: null
    });

    this.setValidatorsForAs2ConfigForm();
  }

  private loadFileConfigForm() {
    const fileConfig = this._configuration?.fileConfig ?? CreateConfigurationUtil.createNewFileDto();
    this.configurationFormFile.setValue({
      fileFormat: fileConfig.fileFormat ?? null,
      isTitleContainedInFile: fileConfig.isTitleContainedInFile ?? true,
      decimalSeperator: fileConfig.decimalSeparator ?? null,
      seperatorCharacter: fileConfig.separatorCharacter ?? null,
      textFormat: fileConfig.textFormat ?? null,
      fileNameSearchPattern: fileConfig.fileNameSearchPattern ?? null,
      possibleSources: fileConfig.possibleSources ?? null,
      filter: fileConfig.filter ?? null,
      fieldAssignments: fileConfig.fieldAssignments ? fileConfig.fieldAssignments.map(fa => fa as unknown as IImportConfigurationFieldAssignmentExtendedDTO) : null,
      sendResponse: fileConfig.sendResponse ?? false,
      navisionImportTemplate: fileConfig.navisionImportTemplate ?? NavisionImportTemplate.None,
      convertEmailContentToPdf: fileConfig.convertEmailContentToPdf ?? false
    });

    if (this.configurationFormFile.controls.fileFormat.value === ImportFileFormat.PDF
      || this.configurationFormGeneral.controls.transferType.value === ImportConfigurationTransferType.Acodis
      || this.configurationFormGeneral.controls.transferType.value === ImportConfigurationTransferType.Magento
      || this.configurationFormGeneral.controls.transferType.value === ImportConfigurationTransferType.Zir
      || this.configurationFormGeneral.controls.importType.value === ImportType.Parashift) {
      this.configurationFormFile.controls.fieldAssignments.setValue([]);

      const acodisWorkflowConfig = this._configuration?.acodisConfig;
      this.configurationFormAcodis.setValue({
        acodisWorkflowId: acodisWorkflowConfig?.acodisWorkflowId ?? null,
        category: acodisWorkflowConfig?.category ?? null,
      });
    } else {
      this.completeFieldAssignments();
    }
    this.setValidatorsForFileConfigForm();
  }

  private loadAcodisConfigForm() {
    const acodisWorkflowConfig = this._configuration?.acodisConfig;
    this.configurationFormAcodis.setValue({
      acodisWorkflowId: acodisWorkflowConfig?.acodisWorkflowId ?? null,
      category: acodisWorkflowConfig?.category ?? null
    });
  }

  private loadManualImportConfigForm() {
    const manualImportConfig = this._configuration?.manualImportConfig;
    this.configurationFormManualImport.setValue({
      templateVersion: manualImportConfig?.templateVersion ?? null
    });
  }

  //Initial values are set in import-configuration.component.ts through the dto
  private initializeForms() {
    this.configurationFormGeneral = this.fb.group<ImportConfigurationGeneralFormType>({
      client: this.fb.control<ClientDTO>(null, [Validators.required]),
      name: this.fb.control<string>(null, [Validators.required]),
      transferType: this.fb.control<ImportConfigurationTransferType>(null, [Validators.required]),
      importType: this.fb.control<ImportType>(ImportType.SalesOrder, [Validators.required]),
      isActive: this.fb.control<boolean>(true, [Validators.required]),
      userAssignments: this.fb.control<ImportConfigurationUserAssignmentDTO[]>([]),
      type: this.fb.control<ImportConfigurationType>(ImportConfigurationType.Configuration),
      clientAccessType: this.fb.control<ImportConfigurationClientAccessType>(ImportConfigurationClientAccessType.Client)
    });

    this.configurationFormTimeschedule = this.fb.group<ImportConfigurationTimeSceduleFormType>({
      startDate: this.fb.control<Date>(null, [Validators.required]),
      hasEndDate: this.fb.control<boolean>(false, [Validators.required]),
      endDate: this.fb.control<Date>(null),
      startTime: this.fb.control<Date>(null, [Validators.required]),
      endTime: this.fb.control<Date>(null),
      repetitionIntervalInMinutes: this.fb.control<number>(0, [Validators.required]),
      weekdays: this.fb.group<WeekdaysFormType>({
        allowedMonday: this.fb.control<boolean>(false),
        allowedTuesday: this.fb.control<boolean>(false),
        allowedWednesday: this.fb.control<boolean>(false),
        allowedThursday: this.fb.control<boolean>(false),
        allowedFriday: this.fb.control<boolean>(false),
        allowedSaturday: this.fb.control<boolean>(false),
        allowedSunday: this.fb.control<boolean>(false),
      })
    });

    this.configurationFormEmail = this.fb.group<ImportConfigurationEmailFormType>({
      emailAccountId: this.fb.control<number>(null, [Validators.required]),
      mandatorySubjectContent: this.fb.control<string>(null),
      mandatoryBodyContent: this.fb.control<string>(null),
      senderEmailAddress: this.fb.control<string>(null)
    });

    this.configurationFormSftp = this.fb.group<ImportConfigurationSftpFormType>({

    });

    this.configurationFormFtp = this.fb.group<ImportConfigurationFtpFormType>({
      url: this.fb.control<string>(null, [Validators.required]),
      port: this.fb.control<number>(null, [Validators.required]),
      ftpClientType: this.fb.control<FTPClientType>(null, [Validators.required]),
      userName: this.fb.control<string>(null, [Validators.required]),
      password: this.fb.control<string>(null, [Validators.required]),
      relativePath: this.fb.control<string>(null),
      deleteFilesAfterTransmission: this.fb.control<boolean>(false, [Validators.required]),
      useCertificate: this.fb.control<boolean>(false, [Validators.required]),
      certificateMediaId: this.fb.control<string>(null),
      certificateMediaName: this.fb.control<string>({ value: null, disabled: true }),
      certificatePassword: this.fb.control<string>(null),
      certificateMediaType: this.fb.control<MediaStorageType>(null),
      certificateContentBase64: this.fb.control<string>(null)
    });

    this.configurationFormRest = this.fb.group<ImportConfigurationRestFormType>({
      restAccessType: this.fb.control<ExportInterfaceConfigurationRESTAuthType>(null, [Validators.required]),
      clientId: this.fb.control<string>({ value: null, disabled: true }),
      clientSecret: this.fb.control<string>({ value: null, disabled: true }),
      apiKey: this.fb.control<string>({ value: null, disabled: true }),
      apiValue: this.fb.control<string>({ value: null, disabled: true }),
      refreshTokenLifetimeInHours: this.fb.control<number>(0, [Validators.required])
    });

    this.configurationFormAs2 = this.fb.group<ImportConfigurationAs2FormType>({
      as2From: this.fb.control<string>(null, [Validators.required]),
      as2To: this.fb.control<string>(null, [Validators.required]),
      useCompression: this.fb.control<boolean>(false, [Validators.required]),
      doSignMessages: this.fb.control<boolean>(false, [Validators.required]),
      certificateMediaId: this.fb.control<string>(null),
      certificateMediaName: this.fb.control<string>({ value: null, disabled: true }),
      certificatePassword: this.fb.control<string>(null),
      certificateMediaType: this.fb.control<MediaStorageType>(null),
      certificateContentBase64: this.fb.control<string>(null)
    });

    this.configurationFormFile = this.fb.group<ImportConfigurationFileFormType>({
      fileFormat: this.fb.control<ImportFileFormat>(null, [Validators.required]),
      isTitleContainedInFile: this.fb.control<boolean>(true),
      decimalSeperator: this.fb.control<ExportInterfaceConfigurationDecimalSeparator>(null),
      seperatorCharacter: this.fb.control<string>(null, [CustomValidatorsFactory.compareFieldSeparaterAndDecimalSeparaterOnControl()]),
      textFormat: this.fb.control<ExportInterfaceConfigurationTextFormat>(null),
      fileNameSearchPattern: this.fb.control<string>(null),
      possibleSources: this.fb.control<ImportSourceFieldDefinitionDTO[]>(null),
      filter: this.fb.control<FilterDTO>(null),
      fieldAssignments: this.fb.control<IImportConfigurationFieldAssignmentExtendedDTO[]>(null),
      sendResponse: this.fb.control<boolean>(false, [Validators.required]),
      navisionImportTemplate: this.fb.control<NavisionImportTemplate>({ value: null, disabled: true }),
      convertEmailContentToPdf: this.fb.control<boolean>(false)
    });

    this.configurationFormAcodis = this.fb.group<ImportConfigurationAcodisFormType>({
      acodisWorkflowId: this.fb.control<number>(null, [Validators.required]),
      category: this.fb.control<string>(null, [Validators.required])
    });

    this.configurationFormManualImport = this.fb.group<ImportConfigurationManualImportFormType>({
      templateVersion: this.fb.control<string>(null, [Validators.required])
    });

    this.configurationFormGeneral.controls.importType.valueChanges.subscribe(() => {
      this.completeFieldAssignments();
      this.setValidatorsForFieldAssignments();
      this.configurationFormFile.controls.fieldAssignments.markAsDirty();
      if (this.configurationFormGeneral.controls.importType.value == ImportType.Parashift) {
        this.configurationFormFile.controls.fileFormat.setValue(ImportFileFormat.PDF);
        this.configurationFormFile.controls.navisionImportTemplate.setValue(NavisionImportTemplate.Pdf);
        this.configurationFormFile.controls.fileFormat.disable();
        this.configurationFormFile.controls.convertEmailContentToPdf.setValue(true);
      } else {
        this.configurationFormFile.controls.fileFormat.enable();
      }

    });

    // this.configurationFormFile.controls.decimalSeperator.valueChanges.subscribe(() => {
    //   // if decimal separator is comma and seperatorCharacter is comma, then mark as invalid

    // });
    // this.configurationFormFile.controls.seperatorCharacter.valueChanges.subscribe(() => {
    //   // if decimal separator is comma and seperatorCharacter is comma, then mark as invalid
    //   this.configurationFormFile.controls.seperatorCharacter.updateValueAndValidity();
    // });
  }

  // private validateSeparatorCharacter() {
  //   if (this.configurationFormFile.controls.decimalSeperator.value == ExportInterfaceConfigurationDecimalSeparator.Comma &&
  //     this.configurationFormFile.controls.seperatorCharacter.value == ',') {
  //     this.configurationFormFile.controls.seperatorCharacter.setErrors({ 'invalidSeperatorCharacter': true });
  //   } else {
  //     this.configurationFormFile.controls.seperatorCharacter.setErrors(null);
  //   }
  //   // if decimal separator is point and seperatorCharacter is point, then mark as invalid
  //   if (this.configurationFormFile.controls.decimalSeperator.value == ExportInterfaceConfigurationDecimalSeparator.Point &&
  //     this.configurationFormFile.controls.seperatorCharacter.value == '.') {
  //     this.configurationFormFile.controls.seperatorCharacter.setErrors({ 'invalidSeperatorCharacter': true });
  //   } else {
  //     this.configurationFormFile.controls.seperatorCharacter.setErrors(null);
  //   }
  // }

  private updateConfigurationFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }

    this.updateGeneralFromForm(configuration);
    if (configuration.transferType == ImportConfigurationTransferType.Email) {
      this.updateEmailConfigFromForm(configuration);
    } else {
      configuration.emailConfig = null;
    }
    if (configuration.transferType == ImportConfigurationTransferType.SFTPServer) {
      this.updateSFTPConfigFromForm(configuration);
    } else {
      configuration.sFTPConfig = null;
    }
    if (configuration.transferType == ImportConfigurationTransferType.FTPClient) {
      this.updateTimeScheduleFromForm(configuration);
      this.updateFTPConfigFromForm(configuration);
    } else {
      configuration.fTPClientConfig = null;
    }
    if (configuration.transferType == ImportConfigurationTransferType.REST) {
      this.updateRESTConfigFromForm(configuration);
    } else {
      configuration.rESTConfig = null;
    }
    if (configuration.transferType == ImportConfigurationTransferType.AS2) {
      this.updateAs2ConfigFromForm(configuration);
    } else {
      configuration.as2Config = null;
    }
    if (configuration.transferType != ImportConfigurationTransferType.REST) {
      this.updateFileConfigFromForm(configuration);
    } else {
      configuration.fileConfig = null;
    }
    if (configuration.transferType === ImportConfigurationTransferType.ManualImport) {
      this.updateManualImportConfigFromForm(configuration);
    } else {
      configuration.manualImportConfig = null;
    }

    if (configuration.fileConfig?.fileFormat === ImportFileFormat.PDF
      || configuration.transferType === ImportConfigurationTransferType.Acodis) {
      this.updateAcodisConfigFromForm(configuration);
    } else {
      configuration.acodisConfig = null;
    }
  }

  private updateGeneralFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }

    configuration.configurationName = this.configurationFormGeneral.value.name;
    configuration.transferType = this.configurationFormGeneral.value.transferType;
    configuration.importType = this.configurationFormGeneral.value.importType;
    configuration.isActive = this.configurationFormGeneral.value.isActive;
    configuration.type = this.configurationFormGeneral.value.type;
    configuration.clientAccessType = this.configurationFormGeneral.value.clientAccessType;
    configuration.userAssignments = this.configurationFormGeneral.value.userAssignments;
  }

  private updateTimeScheduleFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }

    if (!configuration.timeScheduleConfig) {
      configuration.timeScheduleConfig = CreateConfigurationUtil.createNewTimeScheduleDto();
    }
    const timeScheduleDto = configuration.timeScheduleConfig;
    timeScheduleDto.startDate = this.configurationFormTimeschedule.value.startDate ? DateTime.fromJSDate(this.configurationFormTimeschedule.value.startDate) : null;
    timeScheduleDto.hasEndDate = this.configurationFormTimeschedule.value.hasEndDate;
    timeScheduleDto.endDate = this.configurationFormTimeschedule.value.endDate ? DateTime.fromJSDate(this.configurationFormTimeschedule.value.endDate) : null;
    timeScheduleDto.startTime = DurationHelper.fromJSDate(this.configurationFormTimeschedule.value.startTime);
    timeScheduleDto.endTime = DurationHelper.fromJSDate(this.configurationFormTimeschedule.value.endTime);
    timeScheduleDto.repetitionIntervalInMinutes = this.configurationFormTimeschedule.value.repetitionIntervalInMinutes;
    timeScheduleDto.onWeekDays = WeekDayFlagsHelper.daysToFlag(this.configurationFormTimeschedule.value.weekdays as IWeekdays);
  }

  private updateEmailConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }

    if (!configuration.emailConfig) {
      configuration.emailConfig = CreateConfigurationUtil.createNewEmailDto();
    }
    const emailConfigDto = configuration.emailConfig;
    emailConfigDto.emailAccountId = this.configurationFormEmail.value.emailAccountId;
    emailConfigDto.mandatorySubjectContent = this.configurationFormEmail.value.mandatorySubjectContent;
    emailConfigDto.mandatoryBodyContent = this.configurationFormEmail.value.mandatoryBodyContent;
    emailConfigDto.senderEmailAddress = this.configurationFormEmail.value.senderEmailAddress;
  }

  private updateSFTPConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }
    if (!configuration.sFTPConfig) {
      configuration.sFTPConfig = CreateConfigurationUtil.createNewSftpDto();
    }
  }

  private updateFTPConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }
    if (!configuration.fTPClientConfig) {
      configuration.fTPClientConfig = CreateConfigurationUtil.createNewFtpClientDto();
    }
    const ftpClientConfig = configuration.fTPClientConfig;
    ftpClientConfig.url = this.configurationFormFtp.value.url;
    ftpClientConfig.port = this.configurationFormFtp.value.port;
    ftpClientConfig.fTPClientType = this.configurationFormFtp.value.ftpClientType;
    ftpClientConfig.userName = this.configurationFormFtp.value.userName;
    ftpClientConfig.password = this.configurationFormFtp.value.password;
    ftpClientConfig.relativePath = this.configurationFormFtp.value.relativePath;
    ftpClientConfig.deleteFilesAfterTransmission = this.configurationFormFtp.value.deleteFilesAfterTransmission;
    ftpClientConfig.useCertificate = this.configurationFormFtp.value.useCertificate;
    ftpClientConfig.certificateMediaId = this.configurationFormFtp.value.certificateMediaId;
    ftpClientConfig.certificateMediaName = this.configurationFormFtp.getRawValue().certificateMediaName;
    ftpClientConfig.certificatePassword = this.configurationFormFtp.value.certificatePassword;
    ftpClientConfig.certificateMediaType = this.configurationFormFtp.value.certificateMediaType;
    ftpClientConfig.certificateContentBase64 = this.configurationFormFtp.value.certificateContentBase64;
  }

  private updateRESTConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }
    if (!configuration.rESTConfig) {
      configuration.rESTConfig = CreateConfigurationUtil.createNewRestDto();
    }
    const restConfig = configuration.rESTConfig;
    restConfig.accessType = this.configurationFormRest.value.restAccessType;
    restConfig.clientId = this.configurationFormRest.getRawValue().clientId;
    restConfig.clientSecret = this.configurationFormRest.getRawValue().clientSecret;
    restConfig.aPIFixKey = this.configurationFormRest.getRawValue().apiKey;
    restConfig.aPIFixValue = this.configurationFormRest.getRawValue().apiValue;
    restConfig.refreshTokenLifetimeInHours = this.configurationFormRest.value.refreshTokenLifetimeInHours;
  }

  private updateAs2ConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }
    if (!configuration.as2Config) {
      configuration.as2Config = CreateConfigurationUtil.createNewAs2Dto();
    }
    const as2Config = configuration.as2Config;
    as2Config.aS2From = this.configurationFormAs2.value.as2From;
    as2Config.aS2To = this.configurationFormAs2.value.as2To;
    as2Config.useCompression = this.configurationFormAs2.value.useCompression;
    as2Config.doSignMessages = this.configurationFormAs2.value.doSignMessages;
    as2Config.certificateMediaId = this.configurationFormAs2.value.certificateMediaId;
    as2Config.certificateMediaName = this.configurationFormAs2.getRawValue().certificateMediaName;
    as2Config.certificatePassword = this.configurationFormAs2.value.certificatePassword;
    as2Config.certificateMediaType = this.configurationFormAs2.value.certificateMediaType;
    as2Config.certificateContentBase64 = this.configurationFormAs2.value.certificateContentBase64;
  }

  private updateFileConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }
    if (!configuration.fileConfig) {
      configuration.fileConfig = CreateConfigurationUtil.createNewFileDto();
    }
    const fileConfig = configuration.fileConfig;
    fileConfig.fileFormat = this.configurationFormFile.value.fileFormat;
    fileConfig.isTitleContainedInFile = this.configurationFormFile.value.isTitleContainedInFile;
    fileConfig.decimalSeparator = this.configurationFormFile.value.decimalSeperator;
    fileConfig.separatorCharacter = this.configurationFormFile.value.seperatorCharacter;
    fileConfig.textFormat = this.configurationFormFile.value.textFormat;
    fileConfig.fileNameSearchPattern = this.configurationFormFile.value.fileNameSearchPattern;
    fileConfig.filter = this.configurationFormFile.value.filter;
    fileConfig.possibleSources = this.configurationFormFile.value.possibleSources;
    fileConfig.sendResponse = this.configurationFormFile.value.sendResponse;
    fileConfig.navisionImportTemplate = this.configurationFormFile.value.navisionImportTemplate;
    fileConfig.convertEmailContentToPdf = this.configurationFormFile.value.convertEmailContentToPdf;

    this.updateFileConfigFieldAssignmentsFromForm(fileConfig);
    if (this.configurationFormGeneral.value.importType == ImportType.Parashift) {
      fileConfig.fileFormat = ImportFileFormat.PDF;
      fileConfig.navisionImportTemplate = NavisionImportTemplate.Pdf;
    }
  }

  private updateFileConfigFieldAssignmentsFromForm(fileConfig: ImportConfigurationFileDTO) {
    if (!fileConfig) {
      null;
    }
    fileConfig.fieldAssignments = this.configurationFormFile.value.fieldAssignments.map(fa => new ImportConfigurationFieldAssignmentDTO(fa));
  }

  private updateAcodisConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }
    if (!configuration.acodisConfig) {
      configuration.acodisConfig = new ImportConfigurationAcodisDTO();
    }
    const acodisConfig = configuration.acodisConfig;
    acodisConfig.acodisWorkflowId = this.configurationFormAcodis.value.acodisWorkflowId;
    acodisConfig.category = this.configurationFormAcodis.value.category;
  }

  private updateManualImportConfigFromForm(configuration: ImportConfigurationDTO) {
    if (!configuration) {
      null;
    }
    if (!configuration.manualImportConfig) {
      configuration.manualImportConfig = new ImportConfigurationManualImportDTO();
    }
    const manualImportConfig = configuration.manualImportConfig;
    manualImportConfig.templateVersion = this.configurationFormManualImport.value.templateVersion;
  }
}
